import { TrackingProvider } from "../../tracking/trackingProvider";

export enum CommonApplicationActionTypes {
	FETCH_REQUEST_Models = '@@Common/FETCH_REQUEST_MODELS',
	FETCH_SUCCESS_Models = '@@Common/FETCH_SUCCESS_MODELS',

	FETCH_REQUEST_Infotaiments = '@@Common/FETCH_REQUEST_INFOTAIMENTS',
	FETCH_SUCCESS_Infotaiments = '@@Common/FETCH_SUCCESS_INFOTAIMENTS',

	FETCH_REQUEST_Countries = '@@Common/FETCH_REQUEST_COUNTRIES',
	FETCH_SUCCESS_Countries = '@@Common/FETCH_SUCCESS_COUNTRIES',

	FETCH_REQUEST_ImporterSettings = '@@Common/FETCH_REQUEST_IMPORTER_SETTINGS',
	FETCH_SUCCESS_ImporterSettings = '@@Common/FETCH_SUCCESS_IMPORTER_SETTINGS',
}

export interface CommonApplicationState {
	countries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[],
	families: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel[],
	infotainments: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel[],
	importerSettings: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ImporterSettingsModel,
	trackingProvider: TrackingProvider
	readonly errors?: string;
}
